export const COMPANYGROUPBYCOMPANYLIST_SEARCH = 'COMPANYGROUPBYCOMPANYLIST_SEARCH';
export const COMPANYGROUPBYCOMPANYLIST_PAGE = 'COMPANYGROUPBYCOMPANYLIST_PAGE';
